<template>
	<div>
		<div class="row">
			<div
				class="col-md-6 col-xs-6 form-group"
				:class="{'has-error': erro.aeronave.id_aeronave != null}"
			>
				<label>* {{ _traducao('global', 'aeronave') }}:</label>
				<select
					v-model="form.aeronave.id_aeronave"
					class="form-control input-sm"
					@change="
						addTripulacao()
						clickAtualizarRoteiro()
						changeBase()
					"
				>
					<option value="0">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option
						v-for="aeronave in aeronaves"
						:key="aeronave.prefixo"
						:value="aeronave.id"
					>
						{{ aeronave.codinome }} - {{ aeronave.prefixo }}
					</option>
				</select>
				<p class="help-block" v-if="erro.aeronave.id_aeronave != null">
					{{ erro.aeronave.id_aeronave }}
				</p>
			</div>

			<div
				class="col-md-6 col-xs-6 form-group"
				:class="{'has-error': erro.aeronave.base != null}"
			>
				<label>* {{ _traducao('global', 'base') }}:</label>
				<select v-model="form.aeronave.base" class="form-control input-sm" @change="alterarBase()">
					<option value="0">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="base in bases" :key="base.descricao" :value="base.id">
						{{ base.descricao }}
					</option>
				</select>
				<p class="help-block" v-if="erro.aeronave.base != null">
					{{ erro.aeronave.base }}
				</p>
			</div>
		</div>
		<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('rampa', 'tripulacao')" />
		<div v-show="form.aeronave.id_aeronave !== ''">
			<div
				class="row"
				v-for="(trip, idxTrip) in form.aeronave.tripulacao"
				:key="trip.id"
				v-show="trip.alteracao != 'excluir_usuario'"
			>
				<div
					class="col-md-4 col-xs-4 form-group"
					:class="{
						'has-error': form.aeronave.tripulacao[idxTrip].erroFuncao != null
					}"
				>
					<label>{{ _traducao('global', 'funcao') }}:</label>
					<select
						v-model="trip.funcao"
						class="form-control input-sm"
						@change="alteraFuncaoTrip(trip)"
					>
						<option value="0">
							{{ _traducao('global', 'escolha').toUpperCase() }}
						</option>
						<option
							v-for="funcao in getFuncaoQueAssina(idxTrip)"
							:key="funcao.descricao"
							:value="funcao.descricao"
						>
							{{ funcao.nome }}
						</option>
					</select>
					<p
						class="help-block"
						v-if="form.aeronave.tripulacao[idxTrip].erroFuncao != null"
					>
						{{ form.aeronave.tripulacao[idxTrip].erroFuncao }}
					</p>
				</div>
				<div
					class="col-md-5 col-xs-5 form-group"
					:class="{
						'has-error': form.aeronave.tripulacao[idxTrip].erroNome != null
					}"
				>
					<label>* {{ _traducao('global', 'nome') }}:</label>
					<select-items
						@select="
							(po) => {
								adicionaPosicao(form.aeronave.tripulacao[idxTrip], po)
								alteraFuncaoTrip(trip)
							}
						"
						show-disabled
						:items="getTripulantesByFuncao(trip.funcao, funcoes)"
						:label="(po) => `${po.trigrama} - ${po.nome} ${po.codigo_anac}`"
						:active="
							(po) =>
								form.aeronave.tripulacao[idxTrip].usuarios &&
								po.id == form.aeronave.tripulacao[idxTrip].usuarios.id_usuario
						"
						:filter-disabled="(po) => po && po.status == 0"
					/>
					<p
						class="help-block"
						v-if="form.aeronave.tripulacao[idxTrip].erroNome != null"
					>
						{{ form.aeronave.tripulacao[idxTrip].erroNome }}
					</p>
				</div>
				<div class="col-md-3 col-xs-3 form-group">
					<label v-show="!_isMobile" style="color: #f9f9f9">teste:</label>
					<button
						v-show="idxTrip != 0"
						class="btn btn-sm btn-block btn-danger"
						type="button"
						@click.prevent="removerTripulante(trip, idxTrip)"
					>
						<i class="fa fa-trash fa-fw"></i>
						{{ _traducao('global', 'remover').toUpperCase() }}
					</button>
				</div>
			</div>
			<div class="row" v-if="form.aeronave.id_aeronave !== 0">
				<div class="col-md-1 col-xs-1"></div>
				<div class="col-md-3 col-xs-11">
					<button
						class="btn btn-sm btn-block btn-info"
						@click.prevent="clickAddTripulacao(true)"
						type="button"
					>
						<i class="fa fa-fw fa-plus"></i
						>{{ _traducao('global', 'adicionarTripulacao').toUpperCase() }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Cadastro from '../mixins/cadastro.js'
export default {
	mixins: [Cadastro],
	props: {
		form: {
			type: Object,
			required: true
		},
		erro: {
			type: Object,
			required: true
		},
		aeronaves: {
			type: Array,
			required: true
		},
		bases: {
			type: Array,
			required: true
		},
		funcoes: {
			type: Array,
			required: true
		}
	},

	computed: {},

	data() {
		return {
			tripulantes: []
		}
	},

	created() {
		this.carregaTripulanteFuncaoBordo()
	},
	methods: {
		changeBase() {
			if (this.form.aeronave.id_aeronave) {
				const aeronave = this.aeronaves.find(
					(aero) => aero.id == this.form.aeronave.id_aeronave
				)
				if (aeronave) {
					this.form.aeronave.base = aeronave.id_base
				}
			}
		},
		async addTripulacao() {
			if (!this.form.editar) {
				if (this.form.aeronave.novo) {
					this.form.aeronave.tripulacao.push({
						funcao: 'piloto em comando',
						erroNome: null,
						erroFuncao: null,
						usuarios: [],
						load: false,
						usuarios2: [],
						novo: true,
						alteracao: 'inserir_novo_usuario'
					})

					this.form.aeronave.novo = false
					this.form.aeronave.alteracao_aeronave = 'inserir_aeronave'
				}
			} else {
				this.form.aeronave.alteracao_aeronave = 'alteracao_aeronave'
			}
		},

		alterarBase(){
			if(this.form.editar){
				this.form.aeronave.alteracao_aeronave = 'alteracao_aeronave'
			}
		},

		alteraFuncaoTrip(tripulante) {
			if (!tripulante.novo && tripulante.id > 0) {
				tripulante.alteracao = 'editar_usuario'
			}
		},

		removerTripulante(tripulante, idxTrip) {
			if (!tripulante.novo && tripulante.id > 0) {
				tripulante.alteracao = 'excluir_usuario'
			} else {
				this.form.aeronave.tripulacao.splice(idxTrip, 1)
			}
		},

		async getPilotos(idAeronave) {
			return new Promise((resolve) => {
				this._axios(`Usuario/get_tripulacao/${idAeronave}`, 'get', {
					callback(response) {
						if (response._request && response._status) {
							resolve(response.lista)
						}
					}
				})
			})
		},

		buscarNomes() {
			return new Promise((resolve, reject) => {
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'carregando')
				})

				this._httpGet(
					'Classificacao_suprimento_aeronautico/get?tipo=S',
					(retorno) => {
						window.bus.$emit('load-out')

						if (retorno._request && retorno._status) {
							resolve(retorno.lista)
						} else {
							reject('Houve um erro ao tentar buscar os nomes')
						}
					}
				)
			})
		},

		getTripulantesByFuncao(funcao, funcoes) {
			const found = funcoes.find((i) => i.descricao === funcao)
			if (found) {
				return found.tripulantes
			}
			return []
		},

		async clickAddTripulacao(novaTrip = false) {
			let funcao = 0
			this.form.aeronave.tripulacao.push({
				id: null,
				funcao: funcao,
				erroNome: null,
				erroFuncao: null,
				usuarios: [],
				usuarios2: [],
				load: false,
				novo: true,
				alteracao: 'inserir_novo_usuario'
			})
		},

		async getTripulantes() {
			return new Promise((resolve) => {
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'carregando')
				})
				this._axios('Usuario/get_tripulantes', 'get', {
					callback(response) {
						if (response._request && response._status) {
							resolve(response.lista)
						}
					},
					finally: () => {
						window.bus.$emit('load-out')
					}
				})
			})
		},

		async carregaTripulanteFuncaoBordo() {
			if (!this.form.editar) {
				this.tripulantes = await this.getTripulantes()
				this.funcoes = this.funcoes.map((funcao) => {
					funcao.tripulantes = this.tripulantes.filter(
						(tripulante) => tripulante.id_funcao_bordo === funcao.id
					) || []
					return funcao
				})
			}
		},

		adicionaPosicao(tripulante, po) {
			tripulante.usuarios = null
			if(po){
				tripulante.usuarios = {
					apresentacao: null,
					codigo_anac: po.codigo_anac,
					cpf: null,
					funcao: null,
					id: null,
					id_usuario: po.id,
					nome: po.nome,
					tipo_alteracao: 'inserir_novo_usuario',
					trigrama: po.trigrama,
				}
				const func = this.getTripulantesByFuncao(tripulante.funcao, this.funcoes)
				tripulante.usuarios2 = func.filter((t) => t.id === tripulante.usuarios.id_usuario)
			}
		},
		getFuncaoQueAssina(idxTrip) {
      if (idxTrip === 0) {

        return this.funcoes.filter((funcao) => funcao.assina_diario === '1');
      }

      return this.funcoes;
    },
	},

	watch: {}
}
</script>
<style scoped>
.color {
	color: #2196f3;
}

.border-color {
	border-color: #2196f3;
}
</style>